import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap"

export default class extends Controller {
  connect() {
    const urgent = this.element.getAttribute("role") === "alert"
    // Critical alerts persist until dismissed; informational notices auto-hide.
    const options = urgent
      ? { autohide: false }
      : { delay: 5000 }
    const toast = bootstrap.Toast.getOrCreateInstance(this.element, options)
    toast.show()
  }
}
